/* ROCK MY SLEEP Kaufleiste. Markup und CSS: snippets/rms-kaufleiste.liquid.
   Findet den Hauptknopf der Produktseite, zeigt die Leiste unter dem Header, sobald er oben aus dem Bild ist,
   und klickt ihn beim Tippen auf die Leiste. Text, Zustand und Preis werden von der Seite gespiegelt. */
(function () {
  var bar = document.querySelector("[data-rms-kaufleiste]");
  if (!bar || bar.getAttribute("data-ready")) return;
  bar.setAttribute("data-ready", "1");
  var barBtn = bar.querySelector(".rms-kl__btn");
  var preisEl = bar.querySelector("[data-rms-kl-preis]");
  var varEls = bar.querySelectorAll("[data-rms-kl-var]");
  var varianten = null;
  try { var vj = document.querySelector("script[data-rms-kl-varianten]"); if (vj) varianten = JSON.parse(vj.textContent); } catch (e) { varianten = null; }
  var raf = window.requestAnimationFrame || function (f) { return setTimeout(f, 16); };
  var main = null, form = null, kopf = null, bereit = false;
  var imKorb = false, korbTimer = null;
  var GELD = /(\d{1,3}(?:\.\d{3})*,\d{2})\s*€/;

  function sichtbar(el) { var r = el && el.getBoundingClientRect(); return !!(r && r.height > 0 && r.width > 0); }

  /* Hauptknopf: der Kaufknopf im Produktbereich der Seite (nicht in Empfehlungen oder Listen).
     Spieluhr-Landingpages haben je Rockie einen Produktbereich, nur einer ist sichtbar: dann dessen Knopf. */
  function finde() {
    var bereiche = document.querySelectorAll(".product-section");
    if (!bereiche.length) bereiche = [document.querySelector("[data-section-type='product']") || document];
    var erster = null;
    for (var b = 0; b < bereiche.length; b++) {
      var knoepfe = bereiche[b].querySelectorAll("form[action*='/cart/add'] button[name='add'], form[action*='/cart/add'] [type='submit'][name='add']");
      for (var i = 0; i < knoepfe.length; i++) {
        if (knoepfe[i].closest(".rms-kl")) continue;
        if (!erster) erster = knoepfe[i];
        if (bereiche.length < 2 || sichtbar(knoepfe[i])) return knoepfe[i];
        break;
      }
    }
    return erster;
  }

  function warteliste() { var w = document.querySelector(".rms-warteliste"); return sichtbar(w) ? w : null; }

  /* Preis: steht ein Betrag im Hauptknopf (Song "· 3,99 €", Set mit Extras "· 105,00 €"), gilt der. Sonst der angezeigte Preis. */
  function preisLesen() {
    var t = main ? main.textContent : "";
    var m = t.match(GELD);
    if (m) return m[1] + " €";
    var bereich = (main && main.closest(".product-section")) || document;
    var kandidaten = bereich.querySelectorAll(".rms-price-current, .rms-ho-price__now, [data-product-price], .product__price");
    for (var i = 0; i < kandidaten.length; i++) {
      var k = kandidaten[i], cls = k.className || "";
      if (!sichtbar(k) || /compare|old/.test(cls) || k.closest(".rms-kl")) continue;
      var klon = k.cloneNode(true);
      Array.prototype.forEach.call(klon.querySelectorAll(".rms-price-old, .rms-ho-price__old, s, del, [class*='compare']"), function (x) { x.remove(); });
      var mm = klon.textContent.match(GELD);
      if (mm) return mm[1] + " €";
    }
    return null;
  }

  /* Gewählte Variante: aus dem Feld name=id des Formulars, Titel aus der Variantenliste (Optionen mit " / ") */
  function varianteLesen() {
    if (!varianten || !form) return "";
    var feld = form.querySelector("[name='id']");
    var id = feld && feld.value;
    if (!id) return "";
    for (var i = 0; i < varianten.length; i++) {
      if (String(varianten[i].id) === String(id)) {
        var t = varianten[i].title || "";
        return t === "Default Title" ? "" : t;
      }
    }
    return "";
  }

  function spiegeln() {
    if (!main) return;
    var p = preisLesen();
    if (p && preisEl.textContent !== p) preisEl.textContent = p;
    var v = varianteLesen();
    Array.prototype.forEach.call(varEls, function (el) {
      if (el.textContent !== v) el.textContent = v;
      if (v) { el.removeAttribute("hidden"); el.title = v; } else el.setAttribute("hidden", "");
    });
    var text, aus = false;
    var w = warteliste();
    if (imKorb || /✓/.test(main.textContent)) text = "✓ Im Warenkorb";
    else if (w) text = "Zur Gästeliste";
    else if (main.disabled || main.getAttribute("aria-disabled") === "true") { text = (main.textContent || "").replace(/\s+/g, " ").trim() || "Nicht verfügbar"; aus = true; }
    else text = "In den Warenkorb";
    if (barBtn.textContent !== text) barBtn.textContent = text;
    barBtn.disabled = aus;
    barBtn.classList.toggle("is-done", text === "✓ Im Warenkorb");
  }

  /* Leiste direkt unter dem Header: Unterkante des Headers im Bild, 0 wenn er weggescrollt ist */
  var letzteOben = -1;
  function andocken() {
    var oben = 0;
    if (kopf) oben = Math.max(0, Math.min(Math.round(kopf.getBoundingClientRect().bottom), 200));
    if (oben !== letzteOben) { bar.style.setProperty("--rms-kl-top", oben + "px"); letzteOben = oben; }
    return oben;
  }
  function zeige(an) {
    if (bar.classList.contains("is-show") === an) return;
    bar.classList.toggle("is-show", an);
    bar.setAttribute("aria-hidden", an ? "false" : "true");
    barBtn.tabIndex = an ? 0 : -1;
  }
  function pruefe() {
    if (!main) return;
    var oben = andocken();
    var r = main.getBoundingClientRect();
    if (!r.height) { zeige(false); return; } // Knopf noch nicht aufgebaut oder ausgeblendet
    zeige(r.bottom < oben);
  }
  var geplant = false;
  function bald() { if (geplant) return; geplant = true; raf(function () { geplant = false; pruefe(); }); }
  var nach = 0;
  function nachmessen() { nach = 24; (function tick() { pruefe(); if (--nach > 0) raf(tick); })(); }

  barBtn.addEventListener("click", function () {
    if (!main) return;
    if (imKorb) { window.location.href = (window.Shopify && Shopify.routes && Shopify.routes.root || "/") + "cart"; return; }
    /* Seiten mit Bestellformular (Wunschsong, data-rms-kl-ziel): die Leiste springt zum Formular statt hinzuzufügen */
    var ziel = document.querySelector("[data-rms-kl-ziel]");
    if (ziel) {
      ziel.scrollIntoView({ behavior: "smooth", block: "start" });
      var feld = ziel.querySelector("input, select, textarea");
      if (feld) setTimeout(function () { try { feld.focus({ preventScroll: true }); } catch (e) { feld.focus(); } }, 500);
      return;
    }
    var w = warteliste();
    if (w) {
      w.scrollIntoView({ behavior: "smooth", block: "center" });
      var inp = w.querySelector("input[type='email']");
      if (inp) setTimeout(function () { try { inp.focus({ preventScroll: true }); } catch (e) { inp.focus(); } }, 400);
      return;
    }
    if (main.disabled) return;
    /* Pflichtfelder im Formular (z. B. eine fehlende Auswahl): hinscrollen statt hinzufügen */
    if (form && form.checkValidity && !form.checkValidity()) {
      /* auch Felder außerhalb des Formulars, die per form="…" dazugehören (z. B. Wunschsong) */
      var fehlt = null;
      for (var i = 0; i < form.elements.length; i++) { if (form.elements[i].willValidate && !form.elements[i].checkValidity()) { fehlt = form.elements[i]; break; } }
      fehlt = fehlt || main;
      fehlt.scrollIntoView({ behavior: "smooth", block: "center" });
      if (fehlt !== main) {
        fehlt.classList.add("rms-kl-fehlt");
        var weg = function () { fehlt.classList.remove("rms-kl-fehlt"); fehlt.removeEventListener("input", weg); fehlt.removeEventListener("change", weg); };
        fehlt.addEventListener("input", weg); fehlt.addEventListener("change", weg);
        setTimeout(function () { try { fehlt.focus({ preventScroll: true }); } catch (e) { fehlt.focus(); } if (fehlt.reportValidity) fehlt.reportValidity(); }, 450);
      }
      return;
    }
    var vorher = Date.now(), geklappt = false;
    function ok(e) { if (e.detail && e.detail.addToCartBtn && e.detail.addToCartBtn !== main) return; geklappt = true; }
    document.addEventListener("ajaxProduct:added", ok);
    main.click();
    /* Verlangt der Hauptknopf noch etwas (Fehlermeldung, Auswahl), passiert nichts im Warenkorb: dann zur Auswahl scrollen */
    setTimeout(function () {
      document.removeEventListener("ajaxProduct:added", ok);
      if (!geklappt && Date.now() - vorher < 5000 && document.visibilityState !== "hidden") {
        var fehler = document.querySelector(".product-section .errors, .product-section [role='alert'], .product-section .is-invalid");
        (fehler && sichtbar(fehler) ? fehler : main).scrollIntoView({ behavior: "smooth", block: "center" });
      }
    }, 1800);
  });

  document.addEventListener("ajaxProduct:added", function (e) {
    if (!main || (e.detail && e.detail.addToCartBtn && e.detail.addToCartBtn !== main)) return;
    imKorb = true; spiegeln();
    clearTimeout(korbTimer);
    korbTimer = setTimeout(function () { imKorb = false; spiegeln(); }, 3000);
  });

  function start() {
    if (bereit) return;
    main = finde();
    if (!main) return; // keine Kaufseite: keine Leiste
    bereit = true;
    form = main.form || main.closest("form");
    kopf = document.getElementById("SiteHeader") || document.querySelector(".site-header");
    if (bar.parentNode !== document.body) document.body.appendChild(bar);
    spiegeln(); pruefe();
    /* Text, Zustand und Preis der Seite beobachten (Variante, Extras, ausverkauft) */
    if (window.MutationObserver) {
      new MutationObserver(function () { spiegeln(); }).observe(main, { childList: true, characterData: true, subtree: true, attributes: true, attributeFilter: ["disabled", "aria-disabled", "class"] });
      var bereich = main.closest(".product-section") || document.body;
      var mT = null;
      new MutationObserver(function () { clearTimeout(mT); mT = setTimeout(spiegeln, 60); }).observe(bereich, { childList: true, characterData: true, subtree: true });
    }
    document.addEventListener("change", function () { setTimeout(spiegeln, 60); }, true);
    /* Spieluhr-Landingpages: anderer Rockie gewählt (rms-sgs-pick), Knopf, Titel und Preis des sichtbaren Bereichs übernehmen */
    document.addEventListener("rms:abschnitt", function () {
      var neu = finde(); if (!neu || neu === main) return;
      main = neu; form = main.form || main.closest("form");
      var h = main.closest(".product-section"), titelEl = h && h.querySelector(".product-single__title"), ziel = bar.querySelector(".rms-kl__titel");
      if (titelEl && ziel) {
        var t = titelEl.textContent.replace(/\s+/g, " ").trim(), p = t.indexOf(":");
        ziel.textContent = "";
        if (p > 0) { var v = document.createElement("span"); v.className = "rms-kl__vorsatz"; v.textContent = t.slice(0, p + 1) + " "; ziel.appendChild(v); ziel.appendChild(document.createTextNode(t.slice(p + 1).trim())); }
        else ziel.textContent = t;
      }
      if (window.MutationObserver) new MutationObserver(function () { spiegeln(); }).observe(main, { childList: true, characterData: true, subtree: true, attributes: true, attributeFilter: ["disabled", "aria-disabled", "class"] });
      if ("IntersectionObserver" in window) new IntersectionObserver(function () { pruefe(); }).observe(main);
      spiegeln(); pruefe();
    });
    document.addEventListener("click", function (e) { if (e.target.closest && e.target.closest(".product-section")) setTimeout(spiegeln, 120); }, true);
    ["variant:change", "variantChange", "variant:changed"].forEach(function (n) { document.addEventListener(n, function () { setTimeout(spiegeln, 30); }, true); });
    if ("IntersectionObserver" in window) new IntersectionObserver(function () { pruefe(); }).observe(main);
    window.addEventListener("scroll", bald, { passive: true });
    window.addEventListener("resize", bald, { passive: true });
    if (kopf) {
      kopf.addEventListener("animationstart", nachmessen);
      kopf.addEventListener("animationend", pruefe);
      kopf.addEventListener("transitionend", pruefe);
      if (window.ResizeObserver) new ResizeObserver(pruefe).observe(kopf);
      if (window.MutationObserver) new MutationObserver(nachmessen).observe(kopf, { attributes: true, attributeFilter: ["class", "style"] });
    }
    /* Auch bei Anker oder wiederhergestellter Scrollposition stimmt der Zustand */
    setTimeout(pruefe, 0); setTimeout(pruefe, 400);
    window.addEventListener("load", function () { pruefe(); setTimeout(pruefe, 300); });
    window.addEventListener("pageshow", pruefe);
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start); else start();
  window.addEventListener("load", start);
})();
